// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@page {
  size: auto;
}
ion-col {
  padding: var(--spacing-small);
}

ion-input.vehicleInput {
  width: 100%;
  font-size: var(--font-size-small);
}
ion-input.vehicleInput ::ng-deep .label-text-wrapper.sc-ion-input-md .label-text.sc-ion-input-md {
  opacity: 0.8;
}

ion-scroll {
  height: 100%;
}

ion-select.select-popover {
  font-size: var(--font-size-small);
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 599px) {
  ion-select.select-popover,
  ion-input.vehicleInput {
    height: 40px;
    min-height: 40px;
  }
  ::ng-deep .ion-select-popover {
    --max-width: auto;
    --max-height: 30px;
  }
  ::ng-deep .ion-select-popover ion-list ion-radio-group ion-item {
    height: 30px;
    --min-height: 30px;
  }
  ::ng-deep .ion-select-popover ion-list ion-radio-group ion-item::part(native) {
    min-height: 30px;
    height: 30px;
  }
  ion-input.vehicleInput {
    font-size: var(--font-size-medium);
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 600px) and (max-width: 1023px) {
  ion-select.select-popover,
  ion-input.vehicleInput {
    height: 48px;
    min-height: 48px;
  }
  ::ng-deep .ion-select-popover {
    --max-width: auto;
    --max-height: 40px;
  }
  ::ng-deep .ion-select-popover ion-list ion-radio-group ion-item {
    height: 40px;
    --min-height: 40px;
  }
  ::ng-deep .ion-select-popover ion-list ion-radio-group ion-item::part(native) {
    min-height: 40px;
    height: 40px;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1024px) {
  ion-select.select-popover,
  ion-input.vehicleInput {
    height: 56px;
    min-height: 56px;
  }
  ::ng-deep .ion-select-popover {
    --max-width: auto;
    --max-height: 48px;
  }
  ::ng-deep .ion-select-popover ion-list ion-radio-group ion-item {
    height: 48px;
    --min-height: 48px;
  }
  ::ng-deep .ion-select-popover ion-list ion-radio-group ion-item::part(native) {
    min-height: 48px;
    height: 48px;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/pages/vehicle-form/vehicle-form-components/vehicle-details/vehicle-details.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;AACJ;AAEE;EACA,6BAAA;AAAF;;AAGE;EACE,WAAA;EACA,iCAAA;AAAJ;AAGM;EACE,YAAA;AADR;;AAME;EACE,YAAA;AAHJ;;AAME;EACE,iCAAA;AAHJ;;AAME,sEAAA;AAEA,wBAAA;AAEA,2DAAA;AACA;EACE;;IAEE,YAAA;IACA,gBAAA;EALJ;EAQE;IACE,iBAAA;IACA,kBAAA;EANJ;EAUQ;IACE,YAAA;IACA,kBAAA;EARV;EASU;IACE,gBAAA;IACA,YAAA;EAPZ;EAcE;IACE,kCAAA;EAZJ;AACF;AAeE,2BAAA;AAEA,yBAAA;AAEA,6EAAA;AACA;EACE;;IAEE,YAAA;IACA,gBAAA;EAfJ;EAkBE;IACE,iBAAA;IACA,kBAAA;EAhBJ;EAoBQ;IACE,YAAA;IACA,kBAAA;EAlBV;EAmBU;IACE,gBAAA;IACA,YAAA;EAjBZ;AACF;AAwBE,4BAAA;AAEA,yBAAA;AAEA,8DAAA;AACA;EACE;;IAEE,YAAA;IACA,gBAAA;EAxBJ;EA2BE;IAEE,iBAAA;IACA,kBAAA;EA1BJ;EA8BQ;IACE,YAAA;IACA,kBAAA;EA5BV;EA6BU;IACE,gBAAA;IACA,YAAA;EA3BZ;AACF;AAkCE,4BAAA","sourcesContent":["@page{\r\n    size: auto;\r\n  }\r\n\r\n  ion-col {\r\n  padding: var(--spacing-small);\r\n  }\r\n\r\n  ion-input.vehicleInput {\r\n    width: 100%;\r\n    font-size: var(--font-size-small);\r\n\r\n    ::ng-deep .label-text-wrapper.sc-ion-input-md {\r\n      .label-text.sc-ion-input-md {\r\n        opacity: 0.8;\r\n      }\r\n    }\r\n  }\r\n\r\n  ion-scroll {\r\n    height: 100%;\r\n  }\r\n\r\n  ion-select.select-popover {\r\n    font-size: var(--font-size-small);\r\n  }\r\n\r\n  /** Media queries to set font size and spacing based on screen size **/\r\n\r\n  /*#region Small Screens*/\r\n\r\n  /* Styles for screens smaller than 800px wide or 550 high */\r\n  @media (max-width: 599px) {\r\n    ion-select.select-popover,\r\n    ion-input.vehicleInput {\r\n      height: 40px;\r\n      min-height: 40px;\r\n    }\r\n\r\n    ::ng-deep .ion-select-popover {\r\n      --max-width: auto;\r\n      --max-height: 30px;\r\n\r\n      ion-list {\r\n        ion-radio-group {\r\n          ion-item {\r\n            height: 30px;\r\n            --min-height: 30px;\r\n            &::part(native) {\r\n              min-height: 30px;\r\n              height: 30px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    ion-input.vehicleInput {\r\n      font-size: var(--font-size-medium);\r\n    }\r\n  }\r\n\r\n  /*#endregion Small Screens*/\r\n\r\n  /*#region Medium Screens*/\r\n\r\n  /* Styles for medium screens with min with of 800px and min height of 550px */\r\n  @media (min-width: 600px) and (max-width: 1023px) {\r\n    ion-select.select-popover,\r\n    ion-input.vehicleInput {\r\n      height: 48px;\r\n      min-height: 48px;\r\n    }\r\n\r\n    ::ng-deep .ion-select-popover {\r\n      --max-width: auto;\r\n      --max-height: 40px;\r\n\r\n      ion-list {\r\n        ion-radio-group {\r\n          ion-item {\r\n            height: 40px;\r\n            --min-height: 40px;\r\n            &::part(native) {\r\n              min-height: 40px;\r\n              height: 40px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  /*#endregion Medium Screens*/\r\n\r\n  /*#region Larger Screens*/\r\n\r\n  /* Styles for screens larger than 1000px wide and 600px high */\r\n  @media (min-width: 1024px) {\r\n    ion-select.select-popover,\r\n    ion-input.vehicleInput {\r\n      height: 56px;\r\n      min-height: 56px;\r\n    }\r\n\r\n    ::ng-deep .ion-select-popover\r\n    {\r\n      --max-width: auto;\r\n      --max-height: 48px;\r\n\r\n      ion-list {\r\n        ion-radio-group {\r\n          ion-item {\r\n            height: 48px;\r\n            --min-height: 48px;\r\n            &::part(native) {\r\n              min-height: 48px;\r\n              height: 48px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  /*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
